import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';

const ViewButton = ({ rowData }) => {
  const history = useNavigate();
  const handleClick = () => {
    history(
      `view-invoice/${rowData.invoiceUniqueIdentifier}/${rowData.invoiceTypeEnum}`,
    );
  };

  return <Button link onClick={handleClick} icon={'pi pi-eye'} />;
};

export default React.memo(ViewButton);
